import { render } from "./SingleImage.vue?vue&type=template&id=5786b89e"
import script from "./SingleImage.vue?vue&type=script&lang=js"
export * from "./SingleImage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/ktl/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__